import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import SendEmailVerification from '../components/EmailVerification/SendEmailVerification';
import authSlice from '../store/auth/slice';
import { selectAuth, selectCurrentAlias, selectImpersonatedTrackId } from '../store/selectors';
import { AppState } from '../store/state';
import { AppDispatch } from '../store/store';
import { VerifyEmailDTO } from '../store/auth/types';

interface SendEmailVerificationPageProps {
  verifyEmailAction: (data: VerifyEmailDTO) => void;
  sendVerificationEmailAction: () => void;
  logoutAction: () => void;
  email: string;
  isImpersonated: boolean;
  loading: boolean;
}

const SendEmailVerificationPage = ({
  verifyEmailAction,
  sendVerificationEmailAction,
  logoutAction,
  email,
  isImpersonated,
  loading,
}: SendEmailVerificationPageProps) => {
  useEffect(() => {
    !isImpersonated && sendVerificationEmailAction();
  }, []);

  return (
    <SendEmailVerification
      verify_code_handler={verifyEmailAction}
      resend_handler={sendVerificationEmailAction}
      logout_handler={logoutAction}
      email={email}
      loading={loading}
    />
  );
};

const mapStateToProps = (state: AppState) => ({
  email: selectCurrentAlias(state).email,
  isImpersonated: !!selectImpersonatedTrackId(state),
  loading: selectAuth(state).loadingRequest,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  verifyEmailAction: (data: VerifyEmailDTO) => dispatch(authSlice.actions['VERIFY_EMAIL'](data)),
  sendVerificationEmailAction: () => dispatch(authSlice.actions['SEND_VERIFICATION_EMAIL']()),
  logoutAction: () => dispatch(authSlice.actions['LOGOUT']()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SendEmailVerificationPage);
